import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import CustomTree from "./CustomTree2"; // Ensure this imports correctly
import { toggleExpandedForAll } from "react-sortable-tree";
import { Input } from "reactstrap";
import { postApi } from "../../../../redux/api";


function StructureTree2({ editNode = (f) => f, treeData = [], form = {}, update = false }) {
  const [searchText, setSearchText] = useState("");
  const [expanded, setExpanded] = useState(true);
  const [filteredTreeData, setFilteredTreeData] = useState(treeData);
  const [isLoading, setIsLoading] = useState(true);
  const prevUpdateRef = useRef(update); // Ref to track previous update state

  useEffect(() => {
    const expandedTreeData = treeData.map((node) => ({
      ...node,
      expanded,
    }));
    setFilteredTreeData(expandedTreeData);
  }, [expanded, treeData]);

  useEffect(() => {
    setIsLoading(true);
    if (!searchText) {
      setFilteredTreeData(treeData);
    } else {
      const filterTree = (data) =>
        data
          .map((node) => {
            if (
              node.head.toLowerCase().includes(searchText.toLowerCase()) ||
              node.description.toLowerCase().includes(searchText.toLowerCase())
            ) {
              return {
                ...node,
                expanded: true,
                children: node.children ? filterTree(node.children) : [],
              };
            }
            return null;
          })
          .filter((node) => node !== null);
      const filteredData = filterTree(treeData);
      setFilteredTreeData(filteredData);
    }
    setIsLoading(false);
  }, [searchText, treeData]);

  function expand(expanded) {
    if (expanded !== filteredTreeData[0]?.expanded) {
      setFilteredTreeData((prevData) => 
        toggleExpandedForAll({
          treeData,
          expanded,
        })
      );
    }
  }

  useEffect(() => {
    if (update && !filteredTreeData[0]?.expanded && prevUpdateRef.current !== update) {
      expand(true);
    }
    prevUpdateRef.current = update; // Update the ref to the current update state
  }, [update, filteredTreeData]);

  return (
    <>
      <div>
        <div className="col-md-6 m-5 mt-0 mb-1">
          <button onClick={() => expand(true)} className="btn btn-success sm-btn mt-2" style={{ marginRight: "10px" }}>
            Expand All
          </button>
          <button onClick={() => expand(false)} className="btn btn-success sm-btn mt-2">
            Collapse All
          </button>
        </div>
        <div className="col-md-8">
          {isLoading ? (
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <CustomTree
              generateNodeProps={({ node, path }) => {
                const isChecked = form.accessTo?.findIndex((a) => a.head === node.head) !== -1;

                return {
                  title: (
                    <div style={{ textTransform: node.children?.length ? "uppercase" : "capitalize" }}>
                      {`${node.head} - ${node.description}`}
                    </div>
                  ),
                  buttons: [
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      checked={isChecked}
                      onChange={(event) => {
                        editNode(node, event.target.checked);
                      }}
                      style={{ border: "2px solid blue" }}
                      key={path}
                    />,
                  ],
                };
              }}
              treeData={filteredTreeData}
            />
          )}
        </div>
      </div>
    </>
  );
}

StructureTree2.propTypes = {
  editNode: PropTypes.func,
  form: PropTypes.object,
  treeData: PropTypes.array,
  update: PropTypes.bool,
};

export default StructureTree2;


export const getSector = (obj = {}, query = "", cd = (f) => f) => {
  postApi(
    `account?query_type=${query}`,
    obj)
    .then((data) => {
      console.log(data);
      if (data.success && data?.results) {
        cd(data?.results);
      }
    })
    .catch((err) => console.log(err));
};